import {event} from '../modules/event';
import {ajax} from '../modules/ajax';
import Fav from '../modules/Fav';
import Rating from '../modules/Rating';

/*
* По кнопке "Дальше" подгружаем пункты меню
* */

class AjaxContent {
	constructor(wrapper){
		this._createElements(wrapper);
		this._addEvents();
	}

	_createElements(wrapper){
		this.wrapper = wrapper;
		this.param = JSON.parse(this.wrapper.getAttribute('data-param'));
		this.btn = document.querySelector('[data-AjaxContent-btn="' + this.param.type + '"]');
		this.isSending = false;
		this.ajaxPath = this._defineAjaxPath();
		this.ajaxData = this._getAjaxData();
        this.actions = {
            Rating: function(el){return new Rating(el)},
            Fav: function(el){return new Fav(el)}
        };
	}

	_defineAjaxPath(){
		var part = (window.location + '').indexOf('/build/') === -1 ? '' : 'layouts',
			ajaxPath = part + this.btn.getAttribute('href').split('?')[0];

		return ajaxPath;
	}

	_getAjaxData(){
		var search = this.btn.getAttribute('href').split('?')[1].split('&'),
			data = {};

		for(var i= 0,j=search.length; i<j; i++){
			var item = search[i].split('=');
			data[item[0]] = item[1];
		}

		return data;
	}

	_addEvents(){
		var self = this;

		event.add(this.btn, 'click', function(e){
			e.preventDefault();

			if(self.isSending) return false;
			if(this.className.indexOf('js-delete') !== -1) return false;

			self.isSending = true;

			ajax({
				data:self.ajaxData,
				url:self.ajaxPath,
				callback: function(msg){
					self._checkMsg.call(self, msg);
				}
			});
		});
	}

	_checkMsg(msg){
		var msg = JSON.parse(msg);

		if(!msg.moreFrom) {
			if(this.btn.className.indexOf('js-delete') === -1) this.btn.className = this.btn.className + ' js-delete';
			return false;
		}
		this.ajaxData.offset = msg.moreFrom;

		var container = document.createElement('div');
		container.innerHTML = msg.content;


        var subModulesAll = container.querySelectorAll('[data-modules]');
        for(var i=0,j=subModulesAll.length; i<j; i++){
            var nameAll = subModulesAll[i].getAttribute('data-modules').split(' ');
            for(var m=0,n=nameAll.length; m<n; m++){
                if(this.actions[nameAll[m]]) {
                    this.actions[nameAll[m]](subModulesAll[i]);
                }
            }
        }

		while(container.firstChild){
			this.wrapper.appendChild(container.firstChild);
		}

		this.isSending = false;
	}
};

export {AjaxContent};